/**
 * App Vuex Module
 */
import PACKAGE from '@/../package.json'

/**
 * Store state for App module
 */
const state = {
  version: PACKAGE.version,
  name: PACKAGE.description
}

/**
 * Action for App module
 */
const actions = {
}

/**
 * Mutations for App module
 */
const mutations = {
}

/**
 * Getters for App module
 */
const getters = {
  version: state => state.version,
  name: state => state.name
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js